<template>
    <div class="item_sidebar preview-image-props" :class="itemClass">
	    <div class="__switch_inner">
		    <label class="wrapper_title mb_0">
			    <div class="title">
				    Preview selected product
			      <info-icon info="When checked, the image of the currently selected product or variant will be shown instead."/>
			    </div>

			    <span class="switch_checkbox_item">
              <input type="checkbox" :checked="value" @change="updatedData($event.target.checked)">
              <div class="switch_checkbox"><span></span></div>
          </span>
		    </label>
		    <p>
		    </p>
	    </div>

    </div>
</template>

<script>

import InfoIcon from "@/components/base/info-icon";
export default {
    name: 'previewImageProps', components: {InfoIcon}, props: ['title', 'value'],
    methods: {
      updatedData(val){
        this.$emit('updated', val);
      },
    },
	computed:{
		itemClass() {
			return this.title.toLowerCase().split(' ').join('_');
		}
	}
}
</script>
<style lang="scss" scoped>
.preview-image-props {
	margin: 0;
	.title {
		display: flex;
		flex-direction: row;
	}
	//padding: 0 !important;
	.__switch_inner {
		//border-radius: 5px;
		//padding: 8px 5px;
		display: flex;
		flex-direction: column;
		&:hover {
			//background: $light-silver;
			//.title {
			//	text-decoration: underline dashed;
			//	text-decoration-thickness: 1px;
			//	text-decoration-color: $grey;
			//}
		}
	}
	p {
		padding: 0;
		margin: 0;
		margin-right: 50px;
		font-size: 11px;
		line-height: 1.4;
	}
	.wrapper_title {
		cursor: pointer;
	}
}
</style>
